/* Bloom - rastreio de pedido. Sem dependencias. DOM montado so com createElement/textContent. */
(function () {
  'use strict';

  var P = 'bloom-rastreio__';
  var TOKEN_RE = /^[A-Za-z0-9_-]{22}$/;
  var TIMEOUT_MS = 15000;
  var ERROS = ['invalido', 'nao_encontrado', 'limite', 'indisponivel'];
  var MSG = {
    invalido: 'Confira o número do pedido ou o código de rastreio, e o e-mail ou telefone.',
    nao_encontrado: 'Não encontramos um pedido com esses dados. Confira o número no e-mail de confirmação e use o mesmo e-mail ou telefone da compra. Pedidos recentes podem levar alguns dias para aparecer aqui; se precisar, fale com a gente.',
    limite: 'Muitas tentativas seguidas. Aguarde um minuto e tente de novo.',
    indisponivel: 'O rastreio está indisponível agora. Tente de novo em alguns minutos.',
    token: 'Este link de rastreio não é mais válido. Consulte pelo número do pedido.'
  };
  var SITUACAO = {
    preparando: 'Em preparação',
    em_transito: 'Em trânsito',
    na_unidade: 'Na unidade de entrega',
    saiu_entrega: 'Saiu para entrega',
    entregue: 'Entregue',
    cancelado: 'Cancelado'
  };
  /* keys: campos que preenchem a etapa (o primeiro com valor tambem fornece a data exibida).
     also: campos que so servem de evidencia de que a etapa ja aconteceu. */
  var STEPS = [
    { label: 'Pedido realizado', keys: ['compra'] },
    { label: 'Pagamento aprovado', keys: ['pago'] },
    { label: 'Em preparação', keys: ['etiqueta', 'nf'] },
    { label: 'Enviado', keys: ['coleta'], also: ['na_unidade'] },
    { label: 'Saiu para entrega', keys: ['saiu_entrega'] },
    { label: 'Entregue', keys: ['entregue'] }
  ];

  var dtf = null;
  try {
    dtf = new Intl.DateTimeFormat('pt-BR', {
      timeZone: 'America/Sao_Paulo',
      day: '2-digit',
      month: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23'
    });
  } catch (e) {
    dtf = null;
  }

  /* ---------- helpers ---------- */

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text !== undefined && text !== null) n.textContent = text;
    return n;
  }

  function clear(node) {
    node.textContent = '';
  }

  function isStr(v) {
    return typeof v === 'string' && v.length > 0;
  }

  /* ISO (UTC) -> "dd/mm às hh:mm" em America/Sao_Paulo */
  function fmtDateTime(iso) {
    if (!isStr(iso) || !dtf) return '';
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    var p = {};
    dtf.formatToParts(d).forEach(function (x) { p[x.type] = x.value; });
    return p.day + '/' + p.month + ' às ' + p.hour + ':' + p.minute;
  }

  /* "YYYY-MM-DD" -> "dd/mm", sem conversao de fuso */
  function fmtDay(s) {
    var m = isStr(s) && /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
    return m ? m[3] + '/' + m[2] : '';
  }

  /* So aceita http(s) ou caminho relativo de mesmo site (nada de javascript: ou //host) */
  function safeHelpUrl(u) {
    return isStr(u) && /^(\/(?!\/)|https?:\/\/)/i.test(u) ? u : 'https://wa.me/5514991099946?text=Ol%C3%A1!%20Vim%20da%20p%C3%A1gina%20de%20rastreio%20e%20preciso%20de%20ajuda%20com%20meu%20pedido.';
  }

  /* So aceita https no dominio da J&T */
  function safeCarrierUrl(u) {
    if (!isStr(u)) return '';
    try {
      var x = new URL(u);
      return x.protocol === 'https:' && /(^|\.)(jtexpress\.com\.br|rastreamento\.correios\.com\.br)$/i.test(x.hostname) ? x.href : '';
    } catch (e) {
      return '';
    }
  }

  function readToken() {
    var h = new URLSearchParams(location.hash.replace(/^#/, '')).get('t');
    if (h && TOKEN_RE.test(h)) return h;
    var q = new URLSearchParams(location.search).get('t');
    return q && TOKEN_RE.test(q) ? q : null;
  }

  function clearUrlToken() {
    try {
      var u = new URL(location.href);
      u.hash = '';
      u.searchParams.delete('t');
      history.replaceState(null, '', u.pathname + u.search);
    } catch (e) { /* sem acao */ }
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
    return new Promise(function (resolve, reject) {
      var ta = el('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:fixed;top:-1000px;opacity:0';
      document.body.appendChild(ta);
      ta.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
      document.body.removeChild(ta);
      if (ok) resolve(); else reject(new Error('copy'));
    });
  }

  /* ---------- etapas ---------- */

  /* Etapa concluida se ela OU qualquer etapa posterior tem data. Retorna done/current/pending por etapa. */
  function stepStates(etapas) {
    var last = -1;
    STEPS.forEach(function (s, i) {
      var keys = s.keys.concat(s.also || []);
      if (keys.some(function (k) { return !!etapas[k]; })) last = i;
    });
    return STEPS.map(function (s, i) {
      return i <= last ? 'done' : (i === last + 1 ? 'current' : 'pending');
    });
  }

  function stepWhen(step, etapas) {
    for (var i = 0; i < step.keys.length; i++) {
      var k = step.keys[i];
      var v = etapas[k];
      if (!v) continue;
      if (k === 'nf') return { text: fmtDay(v), attr: v };
      return { text: fmtDateTime(v), attr: v };
    }
    return { text: '', attr: '' };
  }

  /* ---------- render do resultado ---------- */

  /* Botão no padrão do tema (hover-link / hover-button com btn-fill e btn-text) */
  function themeButton(tag, cls, text) {
    var isName = tag === 'a' ? 'hover-link' : 'hover-button';
    var n;
    try { n = document.createElement(tag, { is: isName }); } catch (e) { n = document.createElement(tag); }
    n.setAttribute('is', isName);
    n.className = cls;
    var fill = el('span', 'btn-fill');
    fill.setAttribute('data-fill', '');
    n.appendChild(fill);
    n.appendChild(el('span', 'btn-text', text));
    return n;
  }

  function buildResult(d, helpUrl, onReset) {
    var etapas = d.etapas && typeof d.etapas === 'object' ? d.etapas : {};
    var cancelado = d.situacao === 'cancelado';
    var root = el('div', P + 'res');

    function helpLink(text) {
      var a = el('a', P + 'link', text);
      a.href = helpUrl;
      if (/^https?:\/\//i.test(helpUrl)) { a.target = '_blank'; a.rel = 'noopener'; }
      return a;
    }

    /* cabecalho: titulo + selo */
    var head = el('div', P + 'rhead');
    var title = el('h2', 'heading ' + P + 'rtitle', 'Pedido #' + String(d.pedido == null ? '' : d.pedido).slice(0, 12));
    title.tabIndex = -1;
    head.appendChild(title);
    if (Object.prototype.hasOwnProperty.call(SITUACAO, d.situacao)) {
      var ocorre = d.ocorrencia === true && d.situacao !== 'cancelado' && d.situacao !== 'entregue';
      head.appendChild(ocorre
        ? el('span', P + 'badge ' + P + 'badge--ocorrencia', 'Ocorrência na entrega')
        : el('span', P + 'badge ' + P + 'badge--' + d.situacao, SITUACAO[d.situacao]));
    }
    root.appendChild(head);

    if (cancelado) {
      var c = el('p', P + 'cancel', 'Este pedido foi cancelado. ');
      c.appendChild(helpLink('Falar com a gente'));
      root.appendChild(c);
    } else {
      /* stepper */
      var states = stepStates(etapas);
      var ol = el('ol', P + 'steps ' + P + 'steps--wait');
      ol.setAttribute('aria-label', 'Etapas do pedido');
      STEPS.forEach(function (s, i) {
        var st = states[i];
        var li = el('li', P + 'step ' + P + 'step--' + st);
        if (st === 'current') li.setAttribute('aria-current', 'step');
        if (i < STEPS.length - 1 && states[i + 1] !== 'pending') li.className += ' ' + P + 'step--linked';
        /* tempo da etapa: o círculo acende (150 ms) e o trecho seguinte enche (300 ms) */
        li.style.setProperty('--br-dot-delay', (i * 450) + 'ms');
        li.style.setProperty('--br-bar-delay', (i * 450 + 150) + 'ms');
        li.style.setProperty('--br-seg', '300ms');
        if (i < STEPS.length - 1) {
          var bar = el('span', P + 'bar');
          bar.setAttribute('aria-hidden', 'true');
          bar.appendChild(el('span', P + 'bar-fill'));
          li.appendChild(bar);
        }
        var dot = el('span', P + 'dot');
        dot.setAttribute('aria-hidden', 'true');
        dot.appendChild(el('span', P + 'dot-fill'));
        li.appendChild(dot);
        var label = el('span', P + 'label', s.label);
        label.appendChild(el('span', P + 'sr', st === 'done' ? ' (concluída)' : st === 'current' ? ' (próxima etapa)' : ' (pendente)'));
        li.appendChild(label);
        if (st === 'done') {
          var w = stepWhen(s, etapas);
          if (w.text) {
            var t = el('time', P + 'when', w.text);
            t.setAttribute('datetime', w.attr);
            li.appendChild(t);
          }
        }
        ol.appendChild(li);
      });
      root.appendChild(ol);
    }

    /* ocorrencia na entrega */
    if (d.ocorrencia === true && !cancelado) {
      var n = el('p', P + 'notice', 'A transportadora registrou uma ocorrência na entrega. Se precisar, ');
      n.appendChild(helpLink('fale com a gente'));
      n.appendChild(document.createTextNode('.'));
      root.appendChild(n);
    }

    /* codigo de rastreio */
    if (!cancelado) {
      if (isStr(d.codigo)) {
        var code = String(d.codigo).slice(0, 40);
        var box = el('div', P + 'box');
        box.appendChild(el('p', P + 'eyebrow', 'Código de rastreio'));
        var codeEl = el('code', P + 'code', code);
        box.appendChild(codeEl);
        var actions = el('div', P + 'actions');
        var status = el('span', P + 'sr'); /* só para leitor de tela; sem aviso visível */
        status.setAttribute('role', 'status');
        var statusTimer = null;
        function avisar(msg) {
          status.textContent = msg;
          clearTimeout(statusTimer);
          statusTimer = setTimeout(function () { status.textContent = ''; }, 4000);
        }
        var href = safeCarrierUrl(d.link_transportadora);
        if (href) {
          /* botão do tema; ao abrir a J&T o código já vai copiado */
          var a = themeButton('a', 'button button--primary', d.transportadora === 'Correios' ? 'Ver nos Correios' : 'Ver no site da J&T');
          a.href = href;
          a.target = '_blank';
          a.rel = 'noopener noreferrer';
          a.appendChild(el('span', P + 'sr', ' (abre em nova aba)'));
          a.addEventListener('click', function () {
            copyText(code).then(function () { avisar('Código copiado. Se o site pedir, é só colar.'); }, function () {});
          });
          actions.appendChild(a);
        }
        var copyBtn = themeButton('button', 'button button--secondary', 'Copiar código');
        copyBtn.type = 'button';
        var copyText_ = copyBtn.querySelector('.btn-text');
        var timer = null;
        copyBtn.addEventListener('click', function () {
          copyText(code).then(function () {
            copyText_.textContent = 'Copiado';
            avisar('Código copiado.');
            clearTimeout(timer);
            timer = setTimeout(function () { copyText_.textContent = 'Copiar código'; }, 2000);
          }, function () {
            var sel = window.getSelection();
            if (sel) sel.selectAllChildren(codeEl);
          });
        });
        actions.appendChild(copyBtn);
        box.appendChild(actions);
        box.appendChild(status);
        root.appendChild(box);
      } else if (d.situacao !== 'entregue') {
        root.appendChild(el('p', P + 'nocode', 'Assim que a transportadora coletar o pedido, o código aparece aqui.'));
      }
    }

    /* historico */
    var evs = Array.isArray(d.eventos) ? d.eventos.slice(0, 30).filter(function (e) {
      return e && typeof e === 'object' && isStr(e.titulo);
    }) : [];
    if (evs.length) {
      root.appendChild(el('h3', 'heading ' + P + 'subtitle', 'Histórico da entrega'));
      var ul = el('ol', P + 'events');
      evs.forEach(function (e) {
        var li = el('li', P + 'event');
        var when = fmtDateTime(e.em);
        var time = el('time', null, when);
        if (when) time.setAttribute('datetime', e.em);
        li.appendChild(time);
        var info = el('div');
        info.appendChild(el('strong', e.codigo === '110' ? P + 'alerta' : null, e.titulo));
        if (isStr(e.local)) info.appendChild(el('span', null, e.local));
        li.appendChild(info);
        ul.appendChild(li);
      });
      root.appendChild(ul);
    }

    /* rodape */
    var foot = el('div', P + 'foot');
    var upd = fmtDateTime(d.atualizado_em);
    foot.appendChild(el('span', null, upd ? 'Atualizado em ' + upd : ''));
    var reset = el('button', P + 'link', 'Consultar outro pedido');
    reset.type = 'button';
    reset.setAttribute('data-br-reset', '');
    reset.addEventListener('click', onReset);
    foot.appendChild(reset);
    root.appendChild(foot);

    return { node: root, focus: title };
  }

  /* ---------- rede ---------- */

  function request(apiUrl, body) {
    var ctrl = new AbortController();
    var timer = setTimeout(function () { ctrl.abort(); }, TIMEOUT_MS);
    return fetch(apiUrl + '/v1/consulta', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body),
      mode: 'cors',
      credentials: 'omit',
      cache: 'no-store',
      referrerPolicy: 'no-referrer',
      signal: ctrl.signal
    }).then(function (res) {
      return res.json().then(
        function (j) { return { status: res.status, data: j }; },
        function () { return { status: res.status, data: null }; }
      );
    }).then(
      function (r) { clearTimeout(timer); return r; },
      function (e) { clearTimeout(timer); throw e; }
    );
  }

  /* Resposta -> { ok:true, data } | { ok:false, erro }. O campo "erro" tem prioridade sobre o status HTTP. */
  function classify(r) {
    var d = r.data;
    if (d && d.ok === true && isStr(d.situacao) && d.etapas && typeof d.etapas === 'object') return { ok: true, data: d };
    var e = d && isStr(d.erro) ? d.erro : '';
    if (ERROS.indexOf(e) < 0) {
      e = r.status === 400 ? 'invalido' : r.status === 404 ? 'nao_encontrado' : r.status === 429 ? 'limite' : 'indisponivel';
    }
    return { ok: false, erro: e };
  }

  /* ---------- instancia ---------- */

  function init(root) {
    if (root.hasAttribute('data-br-ready')) return;
    var form = root.querySelector('[data-br-form]');
    var wrap = root.querySelector('[data-br-formwrap]');
    var alertBox = root.querySelector('[data-br-alert]');
    var result = root.querySelector('[data-br-result]');
    var intro = root.querySelector('[data-br-intro]');
    var btn = root.querySelector('[data-br-submit]');
    var fPedido = root.querySelector('[name="busca"]');
    var fEmail = root.querySelector('[name="contato"]');
    if (!form || !wrap || !alertBox || !result || !btn || !fPedido || !fEmail) return;
    root.setAttribute('data-br-ready', '');

    var apiUrl = (root.getAttribute('data-api-url') || '').trim().replace(/\/+$/, '');
    var helpUrl = safeHelpUrl(root.getAttribute('data-help-url'));
    var busy = false;

    function setAlert(msg) { alertBox.textContent = msg || ''; }

    function setFieldError(input, msg) {
      var box = root.querySelector('[data-br-error="' + input.name + '"]');
      if (box) box.textContent = msg || '';
      if (msg) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid');
    }

    function showForm() {
      wrap.hidden = false;
      if (intro) intro.hidden = false;
    }

    function validate() {
      var busca = fPedido.value.replace(/[\s.#-]/g, '');
      var contato = fEmail.value.trim();
      var tel = contato.replace(/\D/g, '');
      var ep = '';
      var ee = '';
      if (!busca) ep = 'Informe o número do pedido ou o código de rastreio.';
      else if (!/^\d{3,8}$/.test(busca) && !/^[A-Za-z0-9]{10,30}$/.test(busca)) ep = 'Use o número do pedido (ex.: 140881) ou o código de rastreio.';
      var ehEmail = contato.length <= 254 && /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(contato);
      var ehTel = !/[A-Za-z@]/.test(contato) && tel.length >= 10 && tel.length <= 13;
      if (!contato) ee = 'Informe o e-mail ou o telefone usado na compra.';
      else if (!ehEmail && !ehTel) ee = 'Digite um e-mail (nome@exemplo.com) ou um telefone com DDD.';
      setFieldError(fPedido, ep);
      setFieldError(fEmail, ee);
      if (ep || ee) {
        (ep ? fPedido : fEmail).focus();
        return null;
      }
      return { busca: busca, contato: ehEmail ? contato.toLowerCase() : contato };
    }

    function startLoading(visible) {
      busy = true;
      setAlert('');
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      clear(result);
      var box = el('div', P + 'loading' + (visible ? '' : ' ' + P + 'loading--hidden'));
      if (visible) box.appendChild(el('span', P + 'spinner')).setAttribute('aria-hidden', 'true');
      box.appendChild(el('span', visible ? null : P + 'sr', 'Consultando seu pedido…'));
      result.appendChild(box);
    }

    function stopLoading() {
      busy = false;
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      clear(result);
    }

    function reset() {
      clear(result);
      setAlert('');
      fPedido.value = '';
      fEmail.value = '';
      setFieldError(fPedido, '');
      setFieldError(fEmail, '');
      showForm();
      clearUrlToken();
      fPedido.focus();
    }

    function showResult(d) {
      var r = buildResult(d, helpUrl, reset);
      clear(result);
      result.appendChild(r.node);
      wrap.hidden = true;
      if (intro) intro.hidden = true;
      var steps = r.node.querySelector('.' + P + 'steps--wait');
      if (steps) {
        void steps.offsetWidth;
        setTimeout(function () { steps.classList.remove(P + 'steps--wait'); }, 60);
      }
      r.focus.focus();
    }

    function fail(erro, viaToken) {
      showForm();
      setAlert(viaToken && (erro === 'nao_encontrado' || erro === 'invalido') ? MSG.token : MSG[erro]);
      if (!viaToken) btn.focus();
    }

    function consult(body, viaToken) {
      if (busy) return;
      startLoading(viaToken);
      var run = /^https?:\/\//i.test(apiUrl)
        ? request(apiUrl, body).then(classify, function () { return { ok: false, erro: 'indisponivel' }; })
        : Promise.resolve({ ok: false, erro: 'indisponivel' });
      run.then(function (out) {
        stopLoading();
        if (!out.ok) return fail(out.erro, viaToken);
        try {
          showResult(out.data);
        } catch (e) {
          clear(result);
          fail('indisponivel', viaToken);
        }
      });
    }

    /* Captura no root: impede o listener do hover-button do tema (que ligaria aria-busy sem nunca desligar). */
    root.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      e.preventDefault();
      e.stopPropagation();
      if (busy) return;
      var body = validate();
      if (body) consult(body, false);
    }, true);

    [fPedido, fEmail].forEach(function (f) {
      f.addEventListener('input', function () {
        if (f.getAttribute('aria-invalid') === 'true') setFieldError(f, '');
      });
    });
    fPedido.addEventListener('blur', function () {
      var limpo = fPedido.value.replace(/[\s.#-]/g, '').toUpperCase();
      if (limpo && limpo !== fPedido.value) fPedido.value = limpo;
    });

    /* Pedidos da cliente logada: o card preenche pedido + contato da conta e consulta */
    var mine = root.querySelector('[data-br-mine]');
    if (mine) {
      try {
        var lay = new URLSearchParams(location.search).get('br_layout');
        if (lay === 'grade' || lay === 'lista') mine.className = mine.className.replace(/bloom-rastreio__mine--\w+/, P + 'mine--' + lay);
      } catch (e) { /* sem acao */ }
      mine.addEventListener('click', function (e) {
        var card = e.target.closest && e.target.closest('[data-br-order]');
        if (!card || busy) return;
        fPedido.value = card.getAttribute('data-br-order');
        fEmail.value = mine.getAttribute('data-br-contato') || '';
        setFieldError(fPedido, '');
        setFieldError(fEmail, '');
        var body = validate();
        if (body) consult(body, false);
      });
    }

    var token = readToken();
    if (token) {
      wrap.hidden = true;
      if (intro) intro.hidden = true;
      consult({ t: token }, true);
    }
  }

  function initAll() {
    var nodes = document.querySelectorAll('[data-bloom-rastreio]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (!window.__bloomRastreioBound) {
    window.__bloomRastreioBound = true;
    document.addEventListener('shopify:section:load', initAll);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();
